import actions from './actions';
import initialState from '../initialState';

export const setupCompanyReducer = (state = initialState.setupCompany, action) => {
    switch (action.type) {
        case actions.SAVING_SETUP_COMPANY:
            return { ...state, saving: action.saving };
        case actions.SET_LOADED_STATE:
            return { ...state, loadedState: { ...action.loadedState } };
        case actions.SET_COMPANY_STATE:
            return {
                ...state,
                current: { ...state.current, ...action.company },
            };
        default:
            return state;
    }
};

export default setupCompanyReducer;
